export enum WhereOperators {
    And,
    Or,
    OpenParenthesis,
    CloseParenthesis,
    Filter
}
